/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Modal,
  Button,
} from 'reactstrap';

import {
  Table, Tbody, Tr, Th, Td,
} from 'react-super-responsive-table';

import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// import { Can } from '../../utilities/Can';
// import BaseGrid from '../../components/Common/BaseGrid';
import { get, put, del } from '../../helpers/api_helper';
import TruckForm from '../../components/Sourcing/TruckForm';
import TVTruckManifest from '../../components/TVs/TruckManifest';

function Truck(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const { truckId } = useParams();

  const [entity, setEntity] = useState(null);
  const [tvPallets, setTvPallets] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editEntity, setEditEntity] = useState({});
  const [signal, setSignal] = useState(0);
  const [expectedAt, setExpectedAt] = useState(null);

  const editTruck = (truck) => {
    setEditEntity(truck);
    setModalOpen(true);
  };

  const deleteTruck = async (truck) => {
    // eslint-disable-next-line no-alert
    // eslint-disable-next-line no-restricted-globals
    const cnfrm = confirm(t(`Are you sure you want to delete ${truck.reference}?`));

    if (cnfrm) {
      try {
        await del(`/api/sourcing/trucks/${truck.id}`);

        toastr.success(`Deleted truck ID: ${truck.id}`, 'Success');
        history.back();
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    }
  };

  const markReceived = async () => {
    try {
      const result = await put(`/api/sourcing/trucks/${truckId}`, { received_at: new Date(Date.now()) });

      setSignal(signal + 1);
      toastr.success(t(`Truck ${result.reference} Received`), t('Success'));
    } catch (error) {
      toastr.error(t('Error receiving truck'), t('Error'));
    }
  };

  const downloadLoadedManifest = async () => {
    try {
      const response = await get(`/api/tvs/pallets/loaded-manifest/${truckId}`);
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `loaded_manifest_${entity.reference}.csv`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  useEffect(() => {
    const loadEntity = async () => {
      try {
        const response = await get(`/api/sourcing/trucks/${truckId}`);
        setEntity(response);

        // Get TV pallets
        const tvps = await get(`/api/tvs/pallets/truck/${truckId}`);

        setTvPallets(tvps);

        if (response.expected_at !== null) setExpectedAt(new Date(response.expected_at));
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    };

    loadEntity();
  }, [signal]);

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // For 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const printOutboundLabel = () => {
    window.open(`/sourcing/truck/outbound-label?truck_id=${entity.id}`, '_blank');
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="5">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                <div className="hstack gap-3">
                  <span>{entity !== null ? entity.reference : '--'}</span>
                  {entity !== null && (
                  <span className={`badge ${!entity.outbound ? 'bg-warning text-dark' : 'bg-danger'} p-2`}>
                    <span className="fas fa-truck-moving me-1" />
                    {' '}
                    <span>
                      {!entity.outbound ? t('Inbound') : t('Outbound')}
                    </span>
                  </span>
                  )}
                </div>
              </CardHeader>
              <CardBody>
                <div className="table-responsive">
                  <Table size="sm" className="table table-bordered table-striped">
                    <Tbody>
                      <Tr>
                        <Th>{t('Reference')}</Th>
                        <Td>{entity === null ? '--' : entity.reference}</Td>
                      </Tr>
                      {entity !== null && entity.outbound !== 1 && (
                        <>
                          <Tr>
                            <Th>{t('Expected')}</Th>
                            <Td>{expectedAt === null ? '--' : `${new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: 'UTC' }).format(expectedAt)} the ${expectedAt.getUTCDate()}${getOrdinalSuffix(expectedAt.getUTCDate())}`}</Td>
                          </Tr>
                          <Tr>
                            <Th>{t('Received')}</Th>
                            <Td>
                              {entity === null || entity.received_at === null ? '--' : new Date(entity.received_at).toLocaleString('en-US', {
                                weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric',
                              })}
                            </Td>
                          </Tr>
                        </>
                      )}
                      <Tr>
                        <Th>{t('Supplier')}</Th>
                        <Td>{entity === null || entity.supplier === null ? '--' : entity.supplier.name}</Td>
                      </Tr>
                      <Tr>
                        <Th>{t('Program')}</Th>
                        <Td>{entity === null ? '--' : entity.supplier_program || '--'}</Td>
                      </Tr>
                      {entity !== null && entity.outbound === 1 && (
                      <Tr>
                        <Th>{t('Lanes Staged')}</Th>
                        <Td>{entity === null ? '--' : entity.staged_lanes || '--'}</Td>
                      </Tr>
                      )}
                      {entity !== null && entity.outbound === 1 && (
                      <Tr>
                        <Th>{t('TV Pallets Loaded')}</Th>
                        <Td>
                          {tvPallets.length === 0 ? '--' : tvPallets.map((p) => (
                            <span key={p.id} className="badge bg-primary me-1 fs-5">{p.id.toString(36).toUpperCase()}</span>
                          ))}
                        </Td>
                      </Tr>
                      )}
                    </Tbody>
                  </Table>
                </div>

                <div className="hstack gap-2 mt-3">
                  <Button onClick={() => editTruck(entity)} color="primary" className="me-1">
                    <span className="mdi mdi-pencil" />
                  </Button>
                  <Button onClick={() => deleteTruck(entity)} color="danger" className="btn-soft-danger">
                    <span className="mdi mdi-delete" />
                  </Button>
                  {entity !== null && entity.received_at === null && entity.outbound !== 1 && (
                    <Button onClick={markReceived} color="success" className="btn-soft-success">
                      <span className="mdi mdi-check" />
                      {' '}
                      {t('Mark Received')}
                    </Button>
                  )}
                  {entity !== null && entity.outbound === 1 && (
                    <Button onClick={printOutboundLabel} color="primary" className="btn-soft-primary">
                      <span className="mdi mdi-printer" />
                      {' '}
                      {t('Outbound Label')}
                    </Button>
                  )}

                  {entity !== null && tvPallets !== null && entity.outbound === 1 && (
                    <Button onClick={downloadLoadedManifest} color="primary" className="btn-soft-primary">
                      <span className="mdi mdi-download" />
                      {' '}
                      {t('Download Loaded Manifest')}
                    </Button>
                  )}
                </div>

                {entity !== null && entity.comments !== null && (
                <div className="mt-3">
                  <strong>{t('Comments')}</strong>
                  <blockquote className="mt-1 mb-0">{entity.comments}</blockquote>
                </div>
                )}
              </CardBody>
            </Card>
          </Col>

          <Col md="7">
            {entity !== null && entity.outbound === 1 && (
              <TVTruckManifest truck={entity} onStage={() => { setSignal(signal + 1); }} />
            )}
          </Col>
        </Row>

        <Modal
          size="md"
          isOpen={modalOpen}
        >
          <div className="modal-header">
            <h5
              className="modal-title mt-0"
            >
              {t('Truck Shipment')}
            </h5>
            <button
              onClick={() => setModalOpen(false)}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <TruckForm
              entity={editEntity}
              onSuccess={() => { setModalOpen(false); setSignal(signal + 1); }}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => setModalOpen(false)}
              className="btn btn-soft-dark"
              data-dismiss="modal"
            >
              {t('Cancel')}
            </button>
            <button
              type="submit"
              form="TruckForm"
              className="btn btn-primary"
            >
              {t('Save')}
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
}

Truck.defaultProps = {
  t: (x) => (x),
};

Truck.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Truck));
